const LoginUser = (user) => {
  return {
    type: "LOGIN_USER",
    user,
  };
};

const LogoutUser = () => {
  return {
    type: "LOGOUT_USER",
  };
};

const ExcelSummary = (data) => {
  return {
    type: "EXCEL_SUMMARY",
    data,
  };
};

export const Actions = {
  LoginUser,
  LogoutUser,
  ExcelSummary,
};
